import React from 'react';

function PermSalarySelectField() {
  return '';
}

export default PermSalarySelectField;
